import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

const subjectColors: Record<string, string> = {
  数学: "4F46E5", // indigo
  语文: "DC2626", // red
  英语: "16A34A", // green
  物理: "9333EA", // purple
  化学: "EA580C", // orange
  生物: "0891B2", // cyan
  政治: "EF4444", // bright red
  地理: "10B981", // emerald
  历史: "F59E0B", // amber
  技术: "6366F1", // indigo-lighter
}

export function getExamCoverUrl(subject: string, _title: string, year: number, region: string): string {
  const color = subjectColors[subject] || "3B82F6" // default blue
  const query = `${subject} ${year}年 ${region}`
  return `/placeholder.svg?height=400&width=300&text=${encodeURIComponent(query)}&bg=${color}`
}

// Constants
export const SUBJECTS = ["语文", "数学", "英语", "物理", "化学", "生物", "政治", "地理", "历史", "技术"] as const

export const DIFFICULTY_OPTIONS = ["简单", "中等", "困难"] as const

// Utility functions
export function getYears(): number[] {
  const currentYear = new Date().getFullYear()
  return Array.from({ length: currentYear - 1949 + 1 }, (_, i) => currentYear - i)
}

export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return bytes + " B"
  if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + " KB"
  return (bytes / (1024 * 1024)).toFixed(1) + " MB"
}
